"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useTrackContext_1 = __importDefault(require("../context/Track/useTrackContext"));
const useShare_utils_1 = require("./useShare.utils");
function useShare() {
    const [data, setData] = (0, react_1.useState)(null);
    const track = (0, useTrackContext_1.default)();
    const share = (0, react_1.useCallback)((shareData) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!navigator.share) {
            track(useShare_utils_1.ShareEvent.Share, { shareData });
            navigator.share(shareData);
        }
        else {
            setData(shareData);
        }
    }, []);
    const close = (0, react_1.useCallback)(() => setData(null), [setData]);
    const shareState = (0, react_1.useMemo)(() => ({
        close,
        data,
    }), [close, data]);
    return [share, shareState];
}
exports.default = useShare;
